var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterIconPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 1,
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43ace0",
    d: "M13.576,0H.668A.668.668,0,0,0,.2,1.14L5.342,6.286v5.733a.668.668,0,0,0,.285.547l2.226,1.557A.668.668,0,0,0,8.9,13.576V6.286L14.048,1.14A.668.668,0,0,0,13.576,0Z",
    transform: "translate(8.878 8.878)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconPrimary);
export default __webpack_public_path__ + "static/media/filter-icon-primary.4f5901bb3af45d5cb9e5c673aa3543b8.svg";
export { ForwardRef as ReactComponent };